<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import VueCropper from 'vue-cropperjs';

   export default {
      page: {
         title: "Settings",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader, VueCropper },
      data() {
         return {
            title: "Settings",
            items: [
               {
                  text: "Settings",
                  active: true,
               },                   
            ],
            // time_status: '',
            admin_image: "",
            admin_name: "Clinic",          
            username: "clinic@medicino.com",
            password: "",
            password_confirmation: "",
            android_version: null,
            settings: {
               
            },  
            clinic: {},       
            maintenance: 0,
            maintenance_reason: "",
            booking_charge: 10,
            token: "",
            errors: {},
            image: '',
            preview_image: null,
            show_password: false,
            show_confirm_password: false,
             showCropper: false,
            cropperImage: "",
            cropperOptions: {
               aspectRatio: 1,
               viewMode: 1,
               dragMode: 'move',
               autoCropArea: 0.8,
               restore: false,
               guides: false,
               center: false,
               highlight: false,
               cropBoxMovable: true,
               cropBoxResizable: true,
               toggleDragModeOnDblclick: false,
            },
            isSquareCrop: true,
            print_token_type: 1,
            prescription_print_config: {
               document_title: '',
               header_source: 1,
               custom_clinic_name: '',
               custom_clinic_address: '',
               custom_clinic_phone: '',
               clinic_name_local: '',
               show_doctor_qualification: 1,
               show_doctor_reg_no: 1,
               show_doctor_mobile: 1,
               show_patient_age: 1,
               show_patient_sex: 1,
               show_patient_mobile: 1,
               show_patient_address: 1,
               show_patient_id: 2,
               patient_id_label: 'UHID',
               patient_id_source: 1,
               show_logo: 2,
               show_qr: 1,
               qr_source: 1,
               show_token: 1,
               token_source: 1,
               show_barcode: 1,
               barcode_source: 1,
               vitals: [],
               timing: '',
               disclaimer: '',
               footer_link: '',
               logo_url: '',
               qr_image_url: '',
               barcode_image_url: '',
            },
            logo_file: null,
            logo_preview: null,
            remove_logo: 0,
            qr_image_file: null,
            qr_image_preview: null,
            remove_qr_image: 0,
            barcode_image_file: null,
            barcode_image_preview: null,
            remove_barcode_image: 0,
         };
      },
      mounted() {
    
      },
      created() {
         this.fetchSettings();
      },

      beforeDestroy() {
         // Clean up object URLs to prevent memory leaks
         if (this.cropperImage) {
            URL.revokeObjectURL(this.cropperImage);
         }
         if (this.preview_image) {
            URL.revokeObjectURL(this.preview_image);
         }
         if (this.qr_image_preview) {
            URL.revokeObjectURL(this.qr_image_preview);
         }
         if (this.logo_preview) {
            URL.revokeObjectURL(this.logo_preview);
         }
         if (this.barcode_image_preview) {
            URL.revokeObjectURL(this.barcode_image_preview);
         }
      },
      methods: {
         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 
         fetchSettings() {
            let url = "clinic/settings";         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData.clinic);
               this.clinic = responseData.clinic;
               this.fetchPrescriptionPrintSettings();
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         applyPrescriptionPrintSettings(data) {
            if (!data) {
               return;
            }

            this.print_token_type = data.print_token_type ? Number(data.print_token_type) : 1;
            this.applyPrescriptionPrintConfig(data.prescription_print_config);

            if (this.clinic) {
               this.clinic.print_token_type = this.print_token_type;
               this.clinic.prescription_print_config = this.prescription_print_config;
            }
         },

         fetchPrescriptionPrintSettings() {
            this.getToken();

            this.$axios
               .get("clinic/prescription_print_settings", { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  if (res.data.status) {
                     this.applyPrescriptionPrintSettings(res.data.data);
                  }
               })
               .catch((error) => {
                  if (error.response && error.response.data.message && typeof error.response.data.message !== 'object') {
                     this.$swal("", error.response.data.message, "error");
                  }
               });
         },

         setFile(e) {
            const file = e.target.files[0];
            if (file) {
               // Validate file type
               const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
               if (!allowedTypes.includes(file.type)) {
                  this.$swal("", "Please select a valid image file (JPG, JPEG, PNG)", "error");
                  return;
               }
               
               // Validate file size (max 5MB)
               if (file.size > 5 * 1024 * 1024) {
                  this.$swal("", "Image size should be less than 5MB", "error");
                  return;
               }
               
               this.cropperImage = URL.createObjectURL(file);
               this.showCropper = true;
            }
         },
         updateClinic() {
            
            this.getToken();
            this.errors = {};
            let formData = new FormData();
            formData.append("name", this.clinic.name);
            formData.append("email", this.clinic.username);           
            
            if(this.image) {
               formData.append('image', this.image);
            }

            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            this.loading = true;            
            
            this.$axios
               .post("clinic/ClinicProfileUpdate", formData, config)
               .then((response) => {
                  console.log(response);
                  if (response.data.status) {
                     var user = response.data.data[0];
                     console.log(user);
                     var medicino_clinic = {};
                     if (localStorage.getItem('medicino_clinic')) {
                        medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
                     }

                     medicino_clinic.username = user.username;
                     medicino_clinic.image = user.image;
                     // medicino_clinic.username = user.username;
                     medicino_clinic.name = user.name;

                     localStorage.setItem('medicino_clinic', JSON.stringify(medicino_clinic));
                     
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }

                  //this.clearForm();                  
                  this.$router.go().catch(()=>{});
               })
               .catch((error) => {

                  if (error.response) {
                     console.log(error.response);
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        //this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     //this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },
         changePassword() {

            this.getToken();
            this.errors = {};

            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            var data = JSON.stringify({
               "password": this.password,
               "password_confirmation": this.password_confirmation
            });
            
            this.loading = true;

            this.$axios
               .post("clinic/change-password", data, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.$router.push({ name: "settings" });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         defaultPrescriptionPrintConfig() {
            return {
               document_title: '',
               header_source: 1,
               custom_clinic_name: '',
               custom_clinic_address: '',
               custom_clinic_phone: '',
               clinic_name_local: '',
               show_doctor_qualification: 1,
               show_doctor_reg_no: 1,
               show_doctor_mobile: 1,
               show_patient_age: 1,
               show_patient_sex: 1,
               show_patient_mobile: 1,
               show_patient_address: 1,
               show_patient_id: 2,
               patient_id_label: 'UHID',
               patient_id_source: 1,
               show_logo: 2,
               show_qr: 1,
               qr_source: 1,
               show_token: 1,
               token_source: 1,
               show_barcode: 1,
               barcode_source: 1,
               vitals: [],
               timing: '',
               disclaimer: '',
               footer_link: '',
               logo_url: '',
               qr_image_url: '',
               barcode_image_url: '',
            };
         },

         applyPrescriptionPrintConfig(config) {
            const defaults = this.defaultPrescriptionPrintConfig();
            const merged = Object.assign({}, defaults, config || {});
            ['show_doctor_qualification', 'show_doctor_reg_no', 'show_doctor_mobile', 'show_patient_age', 'show_patient_sex', 'show_patient_mobile', 'show_patient_address', 'show_patient_id', 'show_logo', 'show_qr', 'show_token', 'show_barcode'].forEach((field) => {
               merged[field] = Number(merged[field]) === 2 ? 2 : 1;
            });
            merged.token_source = Number(merged.token_source) === 2 ? 2 : 1;
            merged.barcode_source = Number(merged.barcode_source) === 2 ? 2 : 1;
            merged.qr_source = Number(merged.qr_source) === 2 ? 2 : 1;
            merged.header_source = Number(merged.header_source) === 2 ? 2 : 1;
            merged.patient_id_source = Number(merged.patient_id_source) === 2 ? 2 : 1;
            merged.vitals = Array.isArray(merged.vitals)
               ? merged.vitals.map((v) => String(v || '').trim()).filter(Boolean)
               : [];
            delete merged.show_vitals;
            delete merged.show_patient_name;
            delete merged.barcode_value;
            delete merged.qr_url;
            ['pharmacy_label', 'pharmacy_name', 'pharmacy_address', 'pharmacy_phone', 'pharmacy_note'].forEach((field) => {
               delete merged[field];
            });
            this.prescription_print_config = merged;
            this.logo_file = null;
            this.logo_preview = null;
            this.remove_logo = 0;
            this.qr_image_file = null;
            this.qr_image_preview = null;
            this.remove_qr_image = 0;
            this.barcode_image_file = null;
            this.barcode_image_preview = null;
            this.remove_barcode_image = 0;
         },

         setPrescriptionImage(e, type) {
            const file = e.target.files[0];
            if (!file) {
               return;
            }

            const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
            if (!allowedTypes.includes(file.type)) {
               this.$swal("", "Please select a valid image file (JPG, JPEG, PNG)", "error");
               e.target.value = '';
               return;
            }

            if (file.size > 2 * 1024 * 1024) {
               this.$swal("", "Image size should be less than 2MB", "error");
               e.target.value = '';
               return;
            }

            if (type === 'logo') {
               this.logo_file = file;
               this.logo_preview = URL.createObjectURL(file);
               this.remove_logo = 0;
            } else if (type === 'barcode') {
               this.barcode_image_file = file;
               this.barcode_image_preview = URL.createObjectURL(file);
               this.remove_barcode_image = 0;
            } else {
               this.qr_image_file = file;
               this.qr_image_preview = URL.createObjectURL(file);
               this.remove_qr_image = 0;
            }
         },

         removeLogo() {
            this.logo_file = null;
            this.logo_preview = null;
            this.remove_logo = 1;
            this.prescription_print_config.logo_url = '';
            if (this.$refs.logoImageInput) {
               this.$refs.logoImageInput.value = '';
            }
         },

         removeQrImage() {
            this.qr_image_file = null;
            this.qr_image_preview = null;
            this.remove_qr_image = 1;
            this.prescription_print_config.qr_image_url = '';
            if (this.$refs.qrImageInput) {
               this.$refs.qrImageInput.value = '';
            }
         },

         removeBarcodeImage() {
            this.barcode_image_file = null;
            this.barcode_image_preview = null;
            this.remove_barcode_image = 1;
            this.prescription_print_config.barcode_image_url = '';
            if (this.$refs.barcodeImageInput) {
               this.$refs.barcodeImageInput.value = '';
            }
         },

         addVital() {
            if (!Array.isArray(this.prescription_print_config.vitals)) {
               this.$set(this.prescription_print_config, 'vitals', []);
            }
            if (this.prescription_print_config.vitals.length >= 10) {
               this.$swal("", "You can add up to 10 vitals only.", "warning");
               return;
            }
            this.prescription_print_config.vitals.push('');
         },

         removeVital(index) {
            this.prescription_print_config.vitals.splice(index, 1);
         },

         appendVitalsToFormData(formData, vitals) {
            const labels = (vitals || [])
               .map((v) => String(v || '').trim())
               .filter(Boolean);

            if (labels.length === 0) {
               formData.append('vitals', '[]');
               return;
            }

            labels.forEach((label) => {
               formData.append('vitals[]', label);
            });
         },

         updatePrescriptionPrintSettings() {
            this.getToken();
            this.errors = {};

            const config = this.prescription_print_config;
            const formData = new FormData();
            formData.append('print_token_type', Number(this.print_token_type));
            formData.append('document_title', config.document_title || '');
            formData.append('header_source', Number(config.header_source));
            formData.append('custom_clinic_name', config.custom_clinic_name || '');
            formData.append('custom_clinic_address', config.custom_clinic_address || '');
            formData.append('custom_clinic_phone', config.custom_clinic_phone || '');
            formData.append('clinic_name_local', config.clinic_name_local || '');
            formData.append('show_doctor_qualification', Number(config.show_doctor_qualification));
            formData.append('show_doctor_reg_no', Number(config.show_doctor_reg_no));
            formData.append('show_doctor_mobile', Number(config.show_doctor_mobile));
            formData.append('show_patient_age', Number(config.show_patient_age));
            formData.append('show_patient_sex', Number(config.show_patient_sex));
            formData.append('show_patient_mobile', Number(config.show_patient_mobile));
            formData.append('show_patient_address', Number(config.show_patient_address));
            formData.append('show_patient_id', Number(config.show_patient_id));
            formData.append('patient_id_label', config.patient_id_label || '');
            formData.append('patient_id_source', Number(config.patient_id_source));
            formData.append('show_logo', Number(config.show_logo));
            formData.append('show_qr', Number(config.show_qr));
            formData.append('qr_source', Number(config.qr_source));
            formData.append('show_token', Number(config.show_token));
            formData.append('token_source', Number(config.token_source));
            formData.append('show_barcode', Number(config.show_barcode));
            formData.append('barcode_source', Number(config.barcode_source));
            this.appendVitalsToFormData(formData, config.vitals);
            formData.append('timing', config.timing || '');
            formData.append('disclaimer', config.disclaimer || '');
            formData.append('footer_link', config.footer_link || '');
            formData.append('remove_logo', Number(this.remove_logo));
            formData.append('remove_qr_image', Number(this.remove_qr_image));
            formData.append('remove_barcode_image', Number(this.remove_barcode_image));

            if (this.logo_file) {
               formData.append('logo', this.logo_file);
            }

            if (this.qr_image_file) {
               formData.append('qr_image', this.qr_image_file);
            }

            if (this.barcode_image_file) {
               formData.append('barcode_image', this.barcode_image_file);
            }

            const requestConfig = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            this.loading = true;

            this.$axios
               .post("clinic/prescription_print_settings", formData, requestConfig)
               .then((response) => {
                  if (response.data.status) {
                     if (response.data.data) {
                        this.applyPrescriptionPrintSettings(response.data.data);
                     }
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         timeDisplay(){

            let url = "clinic/display-time-status?clinic_id=" + this.clinic.clinic_id+ "&display_time=" + this.clinic.display_token_time+ "&display_name=" + this.clinic.display_name;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }

               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));

            
         },


         clearForm() {
            this.password = "";
            this.password_confirmation = "";
            this.image = "";
            this.preview_image = "";
            this.showCropper = false;
            this.cropperImage = '';
            this.errors = {};
         },
         togglePassword() {
            if(this.show_password == false) {
               this.show_password = true;
            } else {
               this.show_password = false;
            }
         },

         toggleCurrentPassword() {
            if(this.show_current_password == false) {
               this.show_current_password = true;
            } else {
               this.show_current_password = false;
            }
         },

         toggleConfirmPassword() {
            if(this.show_confirm_password == false) {
               this.show_confirm_password = true;
            } else {
               this.show_confirm_password = false;
            }
         },

         // Crop functionality methods
         cropImage() {
            // Get cropped canvas
            const canvas = this.$refs.cropper.getCroppedCanvas({
               width: 400,
               height: 400,
               imageSmoothingEnabled: true,
               imageSmoothingQuality: 'high',
            });
            
            // Convert canvas to blob
            canvas.toBlob((blob) => {
               // Create a new file from the blob
               const croppedFile = new File([blob], 'cropped-image.jpg', {
                  type: 'image/jpeg',
                  lastModified: Date.now()
               });
               
               this.image = croppedFile;
               this.preview_image = URL.createObjectURL(blob);
               this.showCropper = false;
               
               // Clean up the cropper image URL
               if (this.cropperImage) {
                  URL.revokeObjectURL(this.cropperImage);
                  this.cropperImage = "";
               }
            }, 'image/jpeg', 0.9);
         },
         cancelCrop() {
            this.showCropper = false;
            // Clean up the cropper image URL
            if (this.cropperImage) {
               URL.revokeObjectURL(this.cropperImage);
               this.cropperImage = "";
            }
            // Reset file input
            this.$refs.fileinput.value = '';
         },
         toggleAspectRatio() {
            this.isSquareCrop = !this.isSquareCrop;
            this.cropperOptions.aspectRatio = this.isSquareCrop ? 1 : NaN;
            if (this.$refs.cropper) {
               this.$refs.cropper.setAspectRatio(this.cropperOptions.aspectRatio);
            }
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Clinic Details</h4>
                  <b-form @submit.prevent="updateClinic()">
                     <b-row>
                        <b-col md="4" lg="5" class="form-group">
                           <label class="control-label">Clinic Name <span class="text-danger">*</span></label>
                           <b-form-input v-model="clinic.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
                           <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="5" lg="5" class="form-group">
                           <label class="control-label">Email <span class="text-danger">*</span></label>
                           <b-form-input v-model="clinic.username" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>

                           <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="3" lg="2" class="form-group">
                        </b-col>
                        <b-col md="9" lg="10" class="form-group">
                           <label class="control-label">Clinic image <span class="note">[Allowed Formats: jpg, jpeg, png]</span></label><br>
                           
                           <!-- Current clinic image -->
                           <img v-if="clinic.image && !preview_image" :src="$image_url + clinic.image" class="avatar-sm mb-2" alt="" />
                           
                           <!-- Preview of new/cropped image -->
                           <div v-if="preview_image" class="mt-2">
                              <img class="avatar-sm" :src="preview_image" alt="New Profile Preview">
                              <p class="text-muted small mt-1">New image preview - Click "Choose File" to select a different image</p>
                           </div>
                           
                           <input ref="fileinput" type="file" @change="setFile($event)" accept="image/*" class="form-control image-class"  v-bind:class="{ 'is-invalid': Boolean(errors.image) }"/>
                           
                           <div class="note">Leave this field empty if you don't want to add/edit the image</div>

                           <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" lg="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="submit-button mb-3" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Change Password</h4>
                  <b-form  @submit.prevent="changePassword()">
                     <b-row class="d-flex">
                        <b-col md="5" class="form-group">
                           <label class="control-label">Password</label>
                           <b-input-group>
                           <b-form-input type="password" v-model="password"  v-if="!show_password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                           <b-form-input type="text" v-model="password" v-else v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                           <b-input-group-text @click="togglePassword()">
                                 <i class="fas fa-eye" v-if="show_password"></i>
                                 <i class="fas fa-eye-slash" v-else></i>
                              </b-input-group-text>
                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-input-group>
                        </b-col>

                        <b-col md="5" class="form-group">
                           <label class="control-label">Confirm Password</label>
                           <b-input-group>
                                 <b-form-input type="password" v-model="password_confirmation" v-if="!show_confirm_password" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>
                                 <b-form-input type="text" v-model="password_confirmation" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }" v-else></b-form-input>
                                 <b-input-group-text @click="toggleConfirmPassword()">
                                    <i class="fas fa-eye" v-if="show_confirm_password"></i>
                                    <i class="fas fa-eye-slash" v-else></i>
                                 </b-input-group-text>
                                 <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>  
                           </b-input-group>                            
                        </b-col>

                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>
            <div class="card">
               <div class="card-body">
                  <div class="row">
                  <h4 class="card-title mb-3">Token Vending Machine</h4>
                 
                     <div class="form-group col-md-3">
                        <b-form-checkbox
                           id="checkbox-1"
                           v-model="clinic.display_token_time"
                           name="checkbox-1"
                           value="1"
                           unchecked-value="2"
                        >
                        <span class="ms-2"> Display Time</span>
                        </b-form-checkbox>
                     </div>
                     <div class="form-group col-md-3">
                        <b-form-checkbox
                           v-model="clinic.display_name"
                           name="premium"
                           value="1"
                           unchecked-value="2"
                           >
                           <span class="ms-2"> Display Name</span>
                        </b-form-checkbox>
                     </div>

                     
                     <b-col md="" class="form-group d-flex align-items-end">

                        <b-button type="button" class="mr-3 submit-button" variant="primary" @click="timeDisplay()">Update</b-button>
                     </b-col>
                  </div>
                 
               </div>
            </div>
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Print Settings</h4>
                  <p class="text-muted small mb-3">Choose whether the vending machine prints a token only or a full prescription pad, and customize the prescription layout when prescription mode is enabled.</p>
                  <b-form @submit.prevent="updatePrescriptionPrintSettings()">
                     <h5 class="mb-3">Print Token Type</h5>
                     <b-row class="align-items-center mb-4">
                        <b-col cols="12" class="form-group mb-0">
                           <b-form-radio-group
                              v-model.number="print_token_type"
                              class="mb-0 print-token-type-group"
                              v-bind:class="{ 'is-invalid': Boolean(errors.print_token_type) }"
                           >
                              <div class="d-flex align-items-center flex-wrap">
                                 <b-form-radio :value="1" name="print_token_type">Token only</b-form-radio>
                                 <b-form-radio :value="2" name="print_token_type" class="ms-4">Prescription</b-form-radio>
                              </div>
                           </b-form-radio-group>
                           <div v-for="(val, index) in errors.print_token_type" :key="index" class="invalid-feedback d-block">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>

                     <template v-if="print_token_type === 2">
                     <h4 class="card-title mb-3">Prescription Print Configuration</h4>
                     <p class="text-muted small mb-3">
                        Customize the prescription/token print layout for your clinic. Logo, QR code, token, barcode, and vitals are controlled per clinic below.
                     </p>
                     <h5 class="mb-3">Header</h5>
                     <b-row>
                        <b-col md="8" class="form-group">
                           <label class="control-label d-block mb-2">Clinic Name &amp; Address Source <span class="text-danger">*</span></label>
                           <b-form-radio-group
                              v-model.number="prescription_print_config.header_source"
                              class="mb-0 header-source-group"
                              v-bind:class="{ 'is-invalid': Boolean(errors.header_source) }"
                           >
                              <div class="d-flex align-items-center flex-wrap">
                                 <b-form-radio :value="1" name="header_source">Profile</b-form-radio>
                                 <b-form-radio :value="2" name="header_source" class="ms-4">Custom</b-form-radio>
                              </div>
                           </b-form-radio-group>
                           <div class="note" v-if="Number(prescription_print_config.header_source) === 1">
                              Uses clinic name, place, and mobile from your clinic profile.
                           </div>
                           <div class="note" v-else>
                              Enter a custom clinic name and address for the prescription header.
                           </div>
                           <div v-for="(val, index) in errors.header_source" :key="'header_source-' + index" class="invalid-feedback d-block">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                     <b-row v-if="Number(prescription_print_config.header_source) === 2">
                        <b-col md="4" class="form-group">
                           <label class="control-label">Custom Clinic Name <span class="text-danger">*</span></label>
                           <b-form-input v-model="prescription_print_config.custom_clinic_name" maxlength="120" v-bind:class="{ 'is-invalid': Boolean(errors.custom_clinic_name) }"></b-form-input>
                           <div v-for="(val, index) in errors.custom_clinic_name" :key="'custom_clinic_name-' + index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="4" class="form-group">
                           <label class="control-label">Custom Clinic Address <span class="text-danger">*</span></label>
                           <b-form-input v-model="prescription_print_config.custom_clinic_address" maxlength="255" v-bind:class="{ 'is-invalid': Boolean(errors.custom_clinic_address) }"></b-form-input>
                           <div v-for="(val, index) in errors.custom_clinic_address" :key="'custom_clinic_address-' + index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="4" class="form-group">
                           <label class="control-label">Custom Clinic Phone</label>
                           <b-form-input v-model="prescription_print_config.custom_clinic_phone" maxlength="20" v-bind:class="{ 'is-invalid': Boolean(errors.custom_clinic_phone) }"></b-form-input>
                           <div v-for="(val, index) in errors.custom_clinic_phone" :key="'custom_clinic_phone-' + index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                     <b-row>
                        <!-- Document Title and Clinic Name (Local Language) hidden temporarily -->
                        <b-col md="4" class="form-group">
                           <label class="control-label">Timing</label>
                           <b-form-input v-model="prescription_print_config.timing" maxlength="150" placeholder="e.g. Mon-Sat 9:00 AM - 6:00 PM" v-bind:class="{ 'is-invalid': Boolean(errors.timing) }"></b-form-input>
                           <div v-for="(val, index) in errors.timing" :key="'timing-' + index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>

                     <h5 class="mb-3 mt-2">Display Options</h5>
                     <b-row>
                        <b-col md="3" class="form-group">
                           <b-form-checkbox
                              v-model="prescription_print_config.show_logo"
                              :value="1"
                              :unchecked-value="2"
                           >
                              <span class="ms-2">Show Logo</span>
                           </b-form-checkbox>
                        </b-col>
                        <b-col md="3" class="form-group">
                           <b-form-checkbox
                              v-model="prescription_print_config.show_token"
                              :value="1"
                              :unchecked-value="2"
                           >
                              <span class="ms-2">Show Token Number</span>
                           </b-form-checkbox>
                        </b-col>
                        <b-col md="3" class="form-group">
                           <b-form-checkbox
                              v-model="prescription_print_config.show_barcode"
                              :value="1"
                              :unchecked-value="2"
                           >
                              <span class="ms-2">Show Barcode</span>
                           </b-form-checkbox>
                        </b-col>
                        <b-col md="3" class="form-group">
                           <b-form-checkbox
                              v-model="prescription_print_config.show_qr"
                              :value="1"
                              :unchecked-value="2"
                           >
                              <span class="ms-2">Show QR Code</span>
                           </b-form-checkbox>
                        </b-col>
                     </b-row>
                     <div v-for="(val, index) in errors.show_logo" :key="'show_logo-' + index" class="text-danger small mb-2">
                        <p class="mb-0">{{ val }}</p>
                     </div>
                     <div v-for="(val, index) in errors.show_token" :key="'show_token-' + index" class="text-danger small mb-2">
                        <p class="mb-0">{{ val }}</p>
                     </div>
                     <div v-for="(val, index) in errors.show_barcode" :key="'show_barcode-' + index" class="text-danger small mb-2">
                        <p class="mb-0">{{ val }}</p>
                     </div>
                     <div v-for="(val, index) in errors.show_qr" :key="'show_qr-' + index" class="text-danger small mb-2">
                        <p class="mb-0">{{ val }}</p>
                     </div>

                     <h5 class="mb-3 mt-2">Doctor Details</h5>
                     <p class="text-muted small mb-3">Doctor name always prints. Choose which additional doctor details appear on the prescription.</p>
                     <b-row>
                        <b-col md="4" class="form-group">
                           <b-form-checkbox
                              v-model="prescription_print_config.show_doctor_qualification"
                              :value="1"
                              :unchecked-value="2"
                           >
                              <span class="ms-2">Show Qualification</span>
                           </b-form-checkbox>
                        </b-col>
                        <b-col md="4" class="form-group">
                           <b-form-checkbox
                              v-model="prescription_print_config.show_doctor_reg_no"
                              :value="1"
                              :unchecked-value="2"
                           >
                              <span class="ms-2">Show Reg. No.</span>
                           </b-form-checkbox>
                        </b-col>
                        <b-col md="4" class="form-group">
                           <b-form-checkbox
                              v-model="prescription_print_config.show_doctor_mobile"
                              :value="1"
                              :unchecked-value="2"
                           >
                              <span class="ms-2">Show Mobile</span>
                           </b-form-checkbox>
                        </b-col>
                     </b-row>
                     <div v-for="(val, index) in errors.show_doctor_qualification" :key="'show_doctor_qualification-' + index" class="text-danger small mb-2">
                        <p class="mb-0">{{ val }}</p>
                     </div>
                     <div v-for="(val, index) in errors.show_doctor_reg_no" :key="'show_doctor_reg_no-' + index" class="text-danger small mb-2">
                        <p class="mb-0">{{ val }}</p>
                     </div>
                     <div v-for="(val, index) in errors.show_doctor_mobile" :key="'show_doctor_mobile-' + index" class="text-danger small mb-2">
                        <p class="mb-0">{{ val }}</p>
                     </div>

                     <h5 class="mb-3 mt-2">Patient Details</h5>
                     <p class="text-muted small mb-3">Patient name always prints. Choose which other patient fields appear on the prescription.</p>
                     <b-row>
                        <b-col md="4" class="form-group">
                           <b-form-checkbox
                              v-model="prescription_print_config.show_patient_age"
                              :value="1"
                              :unchecked-value="2"
                           >
                              <span class="ms-2">Show Age</span>
                           </b-form-checkbox>
                        </b-col>
                        <b-col md="4" class="form-group">
                           <b-form-checkbox
                              v-model="prescription_print_config.show_patient_sex"
                              :value="1"
                              :unchecked-value="2"
                           >
                              <span class="ms-2">Show Sex</span>
                           </b-form-checkbox>
                        </b-col>
                        <b-col md="4" class="form-group">
                           <b-form-checkbox
                              v-model="prescription_print_config.show_patient_mobile"
                              :value="1"
                              :unchecked-value="2"
                           >
                              <span class="ms-2">Show Mobile</span>
                           </b-form-checkbox>
                        </b-col>
                     </b-row>
                     <b-row>
                        <b-col md="4" class="form-group">
                           <b-form-checkbox
                              v-model="prescription_print_config.show_patient_address"
                              :value="1"
                              :unchecked-value="2"
                           >
                              <span class="ms-2">Show Address</span>
                           </b-form-checkbox>
                        </b-col>
                        <b-col md="4" class="form-group">
                           <b-form-checkbox
                              v-model="prescription_print_config.show_patient_id"
                              :value="1"
                              :unchecked-value="2"
                           >
                              <span class="ms-2">Show Patient ID (UHID)</span>
                           </b-form-checkbox>
                        </b-col>
                     </b-row>
                     <div v-for="(val, index) in errors.show_patient_age" :key="'show_patient_age-' + index" class="text-danger small mb-2">
                        <p class="mb-0">{{ val }}</p>
                     </div>
                     <div v-for="(val, index) in errors.show_patient_sex" :key="'show_patient_sex-' + index" class="text-danger small mb-2">
                        <p class="mb-0">{{ val }}</p>
                     </div>
                     <div v-for="(val, index) in errors.show_patient_mobile" :key="'show_patient_mobile-' + index" class="text-danger small mb-2">
                        <p class="mb-0">{{ val }}</p>
                     </div>
                     <div v-for="(val, index) in errors.show_patient_address" :key="'show_patient_address-' + index" class="text-danger small mb-2">
                        <p class="mb-0">{{ val }}</p>
                     </div>
                     <div v-for="(val, index) in errors.show_patient_id" :key="'show_patient_id-' + index" class="text-danger small mb-2">
                        <p class="mb-0">{{ val }}</p>
                     </div>

                     <template v-if="Number(prescription_print_config.show_patient_id) === 1">
                        <b-row>
                           <b-col md="4" class="form-group">
                              <label class="control-label">Patient ID Label <span class="text-danger">*</span></label>
                              <b-form-input
                                 v-model="prescription_print_config.patient_id_label"
                                 maxlength="30"
                                 placeholder="e.g. UHID, MRN, Patient ID"
                                 v-bind:class="{ 'is-invalid': Boolean(errors.patient_id_label) }"
                              ></b-form-input>
                              <div class="note">Label shown before the patient ID on the prescription.</div>
                              <div v-for="(val, index) in errors.patient_id_label" :key="'patient_id_label-' + index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           <b-col md="8" class="form-group">
                              <label class="control-label d-block mb-2">Patient ID Source <span class="text-danger">*</span></label>
                              <b-form-radio-group
                                 v-model.number="prescription_print_config.patient_id_source"
                                 class="mb-0 patient-id-source-group"
                                 v-bind:class="{ 'is-invalid': Boolean(errors.patient_id_source) }"
                              >
                                 <div class="d-flex align-items-center flex-wrap">
                                    <b-form-radio :value="1" name="patient_id_source">Medicino ID</b-form-radio>
                                    <b-form-radio :value="2" name="patient_id_source" class="ms-4">Clinic patient ID (entered at consultation)</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                              <div class="note" v-if="Number(prescription_print_config.patient_id_source) === 1">
                                 Prints Medicino patient ID (e.g. UHID: MEDP- 12345).
                              </div>
                              <div class="note" v-else>
                                 Prints the clinic patient ID saved when adding a consultation (e.g. UHID: UHID-9988).
                              </div>
                              <div v-for="(val, index) in errors.patient_id_source" :key="'patient_id_source-' + index" class="invalid-feedback d-block">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>
                     </template>

                     <template v-if="Number(prescription_print_config.show_logo) === 1">
                        <h5 class="mb-3 mt-2">Logo</h5>
                        <b-row>
                           <b-col md="6" class="form-group">
                              <label class="control-label">Print Logo <span class="note">[Allowed: jpg, jpeg, png | Max: 2MB]</span></label>
                              <img
                                 v-if="logo_preview"
                                 :src="logo_preview"
                                 class="avatar-sm mb-2 d-block"
                                 alt="Logo preview"
                              />
                              <img
                                 v-else-if="prescription_print_config.logo_url"
                                 :src="prescription_print_config.logo_url"
                                 class="avatar-sm mb-2 d-block"
                                 alt="Current print logo"
                              />
                              <input
                                 ref="logoImageInput"
                                 type="file"
                                 accept="image/png,image/jpeg,image/jpg"
                                 class="form-control"
                                 @change="setPrescriptionImage($event, 'logo')"
                                 v-bind:class="{ 'is-invalid': Boolean(errors.logo) }"
                              />
                              <div class="note">Upload a logo used on prescription/token prints for this clinic.</div>
                              <b-button
                                 v-if="logo_preview || prescription_print_config.logo_url"
                                 type="button"
                                 variant="outline-danger"
                                 size="sm"
                                 class="mt-2"
                                 @click="removeLogo()"
                              >
                                 Remove Logo
                              </b-button>
                              <div v-for="(val, index) in errors.logo" :key="'logo-' + index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>
                     </template>

                     <template v-if="Number(prescription_print_config.show_token) === 1">
                        <h5 class="mb-3 mt-2">Token</h5>
                        <b-row>
                           <b-col md="6" class="form-group">
                              <label class="control-label d-block mb-2">Token Source <span class="text-danger">*</span></label>
                              <b-form-radio-group
                                 v-model.number="prescription_print_config.token_source"
                                 class="mb-0 token-source-group"
                                 v-bind:class="{ 'is-invalid': Boolean(errors.token_source) }"
                              >
                                 <div class="d-flex align-items-center flex-wrap">
                                    <b-form-radio :value="1" name="token_source">Medicino Token</b-form-radio>
                                    <b-form-radio :value="2" name="token_source" class="ms-4">Clinic Token</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                              <div class="note">Choose whether the printed token number is from Medicino or your clinic.</div>
                              <div v-for="(val, index) in errors.token_source" :key="'token_source-' + index" class="invalid-feedback d-block">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>
                     </template>

                     <template v-if="Number(prescription_print_config.show_barcode) === 1">
                        <h5 class="mb-3 mt-2">Barcode</h5>
                        <b-row>
                           <b-col md="6" class="form-group">
                              <label class="control-label d-block mb-2">Barcode Source <span class="text-danger">*</span></label>
                              <b-form-radio-group
                                 v-model.number="prescription_print_config.barcode_source"
                                 class="mb-0 barcode-source-group"
                                 v-bind:class="{ 'is-invalid': Boolean(errors.barcode_source) }"
                              >
                                 <div class="d-flex align-items-center flex-wrap">
                                    <b-form-radio :value="1" name="barcode_source">Auto Generate</b-form-radio>
                                    <b-form-radio :value="2" name="barcode_source" class="ms-4">Custom Image</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                              <div class="note">Auto generate creates a barcode from the booking ID. Custom image uses your uploaded barcode image.</div>
                              <div v-for="(val, index) in errors.barcode_source" :key="'barcode_source-' + index" class="invalid-feedback d-block">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>
                        <b-row v-if="Number(prescription_print_config.barcode_source) === 2">
                           <b-col md="6" class="form-group">
                              <label class="control-label">Barcode Image <span class="note">[Allowed: jpg, jpeg, png | Max: 2MB]</span> <span class="text-danger">*</span></label>
                              <img
                                 v-if="barcode_image_preview"
                                 :src="barcode_image_preview"
                                 class="avatar-sm mb-2 d-block"
                                 alt="Barcode preview"
                              />
                              <img
                                 v-else-if="prescription_print_config.barcode_image_url"
                                 :src="prescription_print_config.barcode_image_url"
                                 class="avatar-sm mb-2 d-block"
                                 alt="Current barcode"
                              />
                              <input
                                 ref="barcodeImageInput"
                                 type="file"
                                 accept="image/png,image/jpeg,image/jpg"
                                 class="form-control"
                                 @change="setPrescriptionImage($event, 'barcode')"
                                 v-bind:class="{ 'is-invalid': Boolean(errors.barcode_image) }"
                              />
                              <div class="note">Upload a custom barcode image for prescription prints.</div>
                              <b-button
                                 v-if="barcode_image_preview || prescription_print_config.barcode_image_url"
                                 type="button"
                                 variant="outline-danger"
                                 size="sm"
                                 class="mt-2"
                                 @click="removeBarcodeImage()"
                              >
                                 Remove Barcode Image
                              </b-button>
                              <div v-for="(val, index) in errors.barcode_image" :key="'barcode_image-' + index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>
                     </template>

                     <h5 class="mb-3 mt-2">Vitals</h5>
                     <p class="text-muted small mb-3">Add vital labels for the prescription sidebar (e.g. B.P., Wt.). Leave empty to hide the vitals column on print.</p>
                     <div class="form-control border-0 px-0" v-bind:class="{ 'is-invalid': Boolean(errors.vitals) }">
                        <b-row
                           v-for="(vital, index) in prescription_print_config.vitals"
                           :key="'vital-' + index"
                           class="mb-2 align-items-center"
                        >
                           <b-col md="4">
                              <b-form-input
                                 v-model="prescription_print_config.vitals[index]"
                                 maxlength="30"
                                 placeholder="e.g. B.P."
                                 v-bind:class="{ 'is-invalid': Boolean(errors['vitals.' + index]) }"
                              ></b-form-input>
                              <div v-for="(val, errIndex) in errors['vitals.' + index]" :key="'vitals-field-' + index + '-' + errIndex" class="invalid-feedback d-block">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           <b-col md="2" class="d-flex align-items-center">
                              <i
                                 class="fas fa-minus-circle text-danger me-2"
                                 role="button"
                                 @click="removeVital(index)"
                              ></i>
                              <i
                                 v-if="index === prescription_print_config.vitals.length - 1 && prescription_print_config.vitals.length < 10"
                                 class="fas fa-plus-circle text-success"
                                 role="button"
                                 @click="addVital()"
                              ></i>
                           </b-col>
                        </b-row>
                     </div>
                     <b-button
                        v-if="!prescription_print_config.vitals.length"
                        type="button"
                        variant="outline-primary"
                        size="sm"
                        class="mb-3"
                        @click="addVital()"
                     >
                        Add Vital
                     </b-button>
                     <div v-for="(val, index) in errors.vitals" :key="'vitals-' + index" class="text-danger small mb-2">
                        <p class="mb-0">{{ val }}</p>
                     </div>
                     <div class="note mb-3">Maximum 10 vitals, 30 characters each.</div>

                     <template v-if="Number(prescription_print_config.show_qr) === 1">
                        <h5 class="mb-3 mt-2">QR Code</h5>
                        <b-row>
                           <b-col md="6" class="form-group">
                              <label class="control-label d-block mb-2">QR Source <span class="text-danger">*</span></label>
                              <b-form-radio-group
                                 v-model.number="prescription_print_config.qr_source"
                                 class="mb-0 qr-source-group"
                                 v-bind:class="{ 'is-invalid': Boolean(errors.qr_source) }"
                              >
                                 <div class="d-flex align-items-center flex-wrap">
                                    <b-form-radio :value="1" name="qr_source">Auto Generate</b-form-radio>
                                    <b-form-radio :value="2" name="qr_source" class="ms-4">Custom Image</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                              <div class="note">Auto generate builds a QR from patient details. Custom image uses your uploaded QR image.</div>
                              <div v-for="(val, index) in errors.qr_source" :key="'qr_source-' + index" class="invalid-feedback d-block">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>
                        <b-row v-if="Number(prescription_print_config.qr_source) === 2">
                           <b-col md="6" class="form-group">
                              <label class="control-label">QR Image <span class="note">[Allowed: jpg, jpeg, png | Max: 2MB]</span> <span class="text-danger">*</span></label>
                              <img
                                 v-if="qr_image_preview"
                                 :src="qr_image_preview"
                                 class="avatar-sm mb-2 d-block"
                                 alt="QR preview"
                              />
                              <img
                                 v-else-if="prescription_print_config.qr_image_url"
                                 :src="prescription_print_config.qr_image_url"
                                 class="avatar-sm mb-2 d-block"
                                 alt="Current QR"
                              />
                              <input
                                 ref="qrImageInput"
                                 type="file"
                                 accept="image/png,image/jpeg,image/jpg"
                                 class="form-control"
                                 @change="setPrescriptionImage($event, 'qr')"
                                 v-bind:class="{ 'is-invalid': Boolean(errors.qr_image) }"
                              />
                              <div class="note">Upload a custom QR image for prescription prints.</div>
                              <b-button
                                 v-if="qr_image_preview || prescription_print_config.qr_image_url"
                                 type="button"
                                 variant="outline-danger"
                                 size="sm"
                                 class="mt-2"
                                 @click="removeQrImage()"
                              >
                                 Remove QR Image
                              </b-button>
                              <div v-for="(val, index) in errors.qr_image" :key="'qr_image-' + index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>
                     </template>

                     <h5 class="mb-3 mt-2">Footer</h5>
                     <b-row>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Disclaimer</label>
                           <b-form-textarea v-model="prescription_print_config.disclaimer" rows="3" maxlength="500" v-bind:class="{ 'is-invalid': Boolean(errors.disclaimer) }"></b-form-textarea>
                           <div v-for="(val, index) in errors.disclaimer" :key="'disclaimer-' + index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Footer Link / Text</label>
                           <b-form-textarea v-model="prescription_print_config.footer_link" rows="3" maxlength="255" v-bind:class="{ 'is-invalid': Boolean(errors.footer_link) }"></b-form-textarea>
                           <div v-for="(val, index) in errors.footer_link" :key="'footer_link-' + index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>
                     </template>

                     <b-row>
                        <b-col md="12" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update Print Settings</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>
            <!-- <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Charges</h4>
                  <b-form>
                     <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Offline Service Charge <br>(in Rs.)</label>
                           <input type="text" class="form-control" v-model="booking_charge"  v-bind:class="{ 'is-invalid': Boolean(errors.booking_charge) }"/>
                           <div v-for="(val, index) in errors.booking_charge" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="3" class="form-group">
                           <label class="control-label">Regular Delivery Charge per KM <br>(in Rs.)</label>
                           <input type="text" class="form-control" v-model="booking_charge"  v-bind:class="{ 'is-invalid': Boolean(errors.booking_charge) }"/>
                           <div v-for="(val, index) in errors.booking_charge" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="3" class="form-group">
                           <label class="control-label">Express Delivery Charge (Fixed) <br>(in Rs.)</label>
                           <input type="text" class="form-control" v-model="booking_charge"  v-bind:class="{ 'is-invalid': Boolean(errors.booking_charge) }"/>
                           <div v-for="(val, index) in errors.booking_charge" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        
                        <b-col md="3" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div> -->


            <!-- <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Social Media Links</h4>
                  <b-form>
                     <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Facebook</label>
                           <b-form-input v-model="facebook" v-bind:class="{ 'is-invalid': Boolean(errors.facebook) }"></b-form-input>
                           <div v-for="(val, index) in errors.facebook" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Twitter</label>
                           <b-form-input v-model="twitter" v-bind:class="{ 'is-invalid': Boolean(errors.twitter) }"></b-form-input>
                           <div v-for="(val, index) in errors.twitter" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Instagram</label>
                           <b-form-input v-model="instagram" v-bind:class="{ 'is-invalid': Boolean(errors.instagram) }"></b-form-input>
                           <div v-for="(val, index) in errors.instagram" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div> -->


            <!-- <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Maintenance Mode</h4>
                  <b-form>
                     <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Maintenance</label>
                           <select v-model="maintenance" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.maintenance) }">
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                           </select>
                           <div v-for="(val, index) in errors.maintenance" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Reason for Maintenance</label>
                           <b-form-input v-model="maintenance_reason" v-bind:class="{ 'is-invalid': Boolean(errors.reason) }"></b-form-input>
                           <div v-for="(val, index) in errors.reason" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>

               </div>
            </div> -->

            <!-- <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Version Control</h4>
                  <b-form>
                     <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Android</label>
                           <b-form-input v-model="android_version" v-bind:class="{ 'is-invalid': Boolean(errors.android) }"></b-form-input>
                           <div v-for="(val, index) in errors.android" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" class="form-group">
                           <label class="control-label">IOS</label>
                           <b-form-input v-model="ios_version" v-bind:class="{ 'is-invalid': Boolean(errors.ios) }"></b-form-input>
                           <div v-for="(val, index) in errors.ios" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div> -->


         </div>
      </div>

      <!-- Image Cropper Modal -->
      <b-modal 
         v-model="showCropper" 
         title="Crop Profile Image" 
         size="lg" 
         centered 
         hide-footer
         @hide="cancelCrop"
         class="cropper-modal">
         
         <div class="cropper-container">
            <vue-cropper
               ref="cropper"
               :src="cropperImage"
               :aspect-ratio="cropperOptions.aspectRatio"
               :view-mode="cropperOptions.viewMode"
               :drag-mode="cropperOptions.dragMode"
               :auto-crop-area="cropperOptions.autoCropArea"
               :restore="cropperOptions.restore"
               :guides="cropperOptions.guides"
               :center="cropperOptions.center"
               :highlight="cropperOptions.highlight"
               :crop-box-movable="cropperOptions.cropBoxMovable"
               :crop-box-resizable="cropperOptions.cropBoxResizable"
               :toggle-drag-mode-on-dblclick="cropperOptions.toggleDragModeOnDblclick"
               class="cropper-wrapper">
            </vue-cropper>
         </div>
         
         <div class="cropper-controls mt-3">
            <div class="d-flex justify-content-between align-items-center">
               <div>
                  <button type="button" class="btn btn-outline-primary btn-sm" @click="toggleAspectRatio">
                     <i class="bx bx-crop"></i> 
                     {{ isSquareCrop ? 'Free Ratio' : 'Square Crop' }}
                  </button>
               </div>
               <div>
                  <button type="button" class="btn btn-secondary me-2" @click="cancelCrop">
                     <i class="bx bx-x"></i> Cancel
                  </button>
                  <button type="button" class="btn btn-primary" @click="cropImage">
                     <i class="bx bx-check"></i> Crop & Save
                  </button>
               </div>
            </div>
         </div>
      </b-modal>
   </Layout>
</template>

<style scoped>
.cropper-container {
   height: 400px;
   width: 100%;
}

.cropper-wrapper {
   height: 100%;
   width: 100%;
}

.cropper-controls {
   border-top: 1px solid #e9ecef;
   padding-top: 1rem;
}

.avatar-sm {
   width: 80px;
   height: 80px;
   object-fit: cover;
   border-radius: 8px;
   border: 2px solid #e9ecef;
}

.avatar-md {
   width: 120px;
   height: 120px;
   object-fit: cover;
   border-radius: 8px;
   border: 2px solid #e9ecef;
}

/* Cropper modal specific styles */
.cropper-modal .modal-dialog {
   max-width: 800px;
}

.cropper-modal .modal-body {
   padding: 1rem;
}

.note {
   font-size: 12px;
   color: #6c757d;
   font-style: italic;
}

.print-token-type-group >>> .custom-control,
.print-token-type-group >>> .form-check {
   display: inline-flex;
   margin-right: 0;
   padding-left: 1.5rem;
}

.token-source-group >>> .custom-control,
.token-source-group >>> .form-check {
   display: inline-flex;
   margin-right: 0;
   padding-left: 1.5rem;
}

.header-source-group >>> .custom-control,
.header-source-group >>> .form-check {
   display: inline-flex;
   margin-right: 0;
   padding-left: 1.5rem;
}

.patient-id-source-group >>> .custom-control,
.patient-id-source-group >>> .form-check {
   display: inline-flex;
   margin-right: 0;
   padding-left: 1.5rem;
}

.barcode-source-group >>> .custom-control,
.barcode-source-group >>> .form-check {
   display: inline-flex;
   margin-right: 0;
   padding-left: 1.5rem;
}
</style>
